// src/App.tsx
import AppRoutes from './routes';
import { RecipeInteractionsProvider } from './contexts/RecipeInteractionsContext';
import { AuthProvider } from './contexts/AuthContext';
import { FamilyProvider } from './contexts/FamilyContext';
import { TeamProvider } from './contexts/TeamContext';
import AuthRedirect from './components/AuthRedirect';
import OnboardingGate from './components/OnboardingGate';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { SocketProvider } from './hooks/useSocket';

import { useGlobalTextFormatter } from './hooks/useGlobalTextFormatter';

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || '';

function App() {
  useGlobalTextFormatter();

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <AuthProvider>
        <FamilyProvider>
          <TeamProvider>
            <RecipeInteractionsProvider>
              <AuthRedirect />
              <SocketProvider />
              <OnboardingGate>
                <AppRoutes />
              </OnboardingGate>
            </RecipeInteractionsProvider>
          </TeamProvider>
        </FamilyProvider>
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
